import {
  ALL_CATEGORIES_DE_SELECTED,
  ALL_CATEGORIES_SELECTED,
  ALL_MAIL_CLASSES_DE_SELECTED,
  ALL_MAIL_CLASSES_SELECTED,
  FETCH_MAIL_CLASSES,
  FETCH_MAIL_CLASSES_FAILURE,
  FETCH_MAIL_CLASSES_SUCCESS,
  MAIL_CLASS_EXPANDED,
  MAIL_CLASS_SELECTED,
  SHOW_ONLY_SELECTED_MAIL_CLASSES,
} from './types/ProductActionTypes';

export function fetchMailClasses(checkedMailClasses) {
  return {
    type: FETCH_MAIL_CLASSES,
    checkedMailClasses,
  };
}

export function fetchMailClassesSuccess(data) {
  return {
    type: FETCH_MAIL_CLASSES_SUCCESS,
    data,
  };
}

export function fetchMailClassesFailure(error) {
  return {
    type: FETCH_MAIL_CLASSES_FAILURE,
    error,
  };
}

export function mailClassExpanded(category, expanded) {
  return {
    type: MAIL_CLASS_EXPANDED,
    expanded,
    category,
  };
}

export function mailClassSelected(category, selected, propogateSelectionToRoot) {
  return {
    type: MAIL_CLASS_SELECTED,
    category,
    selected,
    propogateSelectionToRoot,
  };
}

export function selectAllMailClasses(category) {
  return {
    type: ALL_MAIL_CLASSES_SELECTED,
    category,
  };
}

export function deSelectAllMailClasses(category) {
  return {
    type: ALL_MAIL_CLASSES_DE_SELECTED,
    category,
  };
}

export function selectAllCategories() {
  return {
    type: ALL_CATEGORIES_SELECTED,
  };
}

export function deSelectAllCategories() {
  return {
    type: ALL_CATEGORIES_DE_SELECTED,
  };
}

export function showOnlySelectedMailClasses() {
  return {
    type: SHOW_ONLY_SELECTED_MAIL_CLASSES,
  };
}
